import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const WA_HREF = 'https://wa.me/905325416344?text=Merhaba%2C%20bilgi%20almak%20istiyorum.';
const PHONE_HREF = 'tel:+905325416344';

const contactItems = [
  {
    icon: 'ri-phone-line',
    title: 'Telefon',
    value: '0532 541 63 44',
    sub: 'Her gün 10:00 - 22:00',
    href: PHONE_HREF,
    iconBg: 'bg-orange-100',
    iconColor: 'text-orange-500',
    hoverBorder: 'hover:border-orange-300',
    hoverBg: 'hover:bg-orange-50',
  },
  {
    icon: 'ri-whatsapp-line',
    title: 'WhatsApp',
    value: '0532 541 63 44',
    sub: '7/24 mesaj atabilirsiniz',
    href: WA_HREF,
    iconBg: 'bg-green-100',
    iconColor: 'text-green-600',
    hoverBorder: 'hover:border-green-300',
    hoverBg: 'hover:bg-green-50',
  },
  {
    icon: 'ri-mail-line',
    title: 'E-posta',
    value: 'goldbilisim532@gmail.com',
    sub: '24 saat içinde yanıt',
    href: 'mailto:goldbilisim532@gmail.com',
    iconBg: 'bg-orange-100',
    iconColor: 'text-orange-500',
    hoverBorder: 'hover:border-orange-300',
    hoverBg: 'hover:bg-orange-50',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Adres',
    value: 'Çevreli Cad. Çaba Sok. No:1/D10',
    sub: 'Aydınlıkevler / ANKARA',
    href: 'https://maps.google.com/?q=Aydınlıkevler+Ankara',
    iconBg: 'bg-orange-100',
    iconColor: 'text-orange-500',
    hoverBorder: 'hover:border-orange-300',
    hoverBg: 'hover:bg-orange-50',
  },
  {
    icon: 'ri-time-line',
    title: 'Çalışma Saatleri',
    value: 'Her Gün: 10:00 - 22:00',
    sub: 'Hafta sonu dahil açığız',
    href: null,
    iconBg: 'bg-slate-100',
    iconColor: 'text-slate-500',
    hoverBorder: 'hover:border-slate-200',
    hoverBg: 'hover:bg-slate-50',
  },
];

const IletisimPage = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'sending' | 'done' | 'error'>('idle');

  const { ref: heroRef, visible: heroVisible } = useScrollReveal(0.1);
  const { ref: cardsRef, visible: cardsVisible } = useScrollReveal(0.05);
  const { ref: formRef, visible: formVisible } = useScrollReveal(0.05);
  const { ref: mapRef, visible: mapVisible } = useScrollReveal(0.1);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (form.message.length > 500) return;
    setStatus('sending');
    try {
      const body = new URLSearchParams();
      Object.entries(form).forEach(([k, v]) => body.append(k, v));
      body.append('_replyto', form.email);
      body.append('_to', 'goldbilisim532@gmail.com');
      await fetch('https://readdy.ai/api/form/d7agkkibdfubkqslam1g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setStatus('done');
      setForm({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />

      {/* Hero */}
      <div className="pt-16 md:pt-20 bg-slate-900 text-white py-14 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10 pointer-events-none"
          style={{
            backgroundImage: 'linear-gradient(rgba(255,165,0,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(255,165,0,0.3) 1px, transparent 1px)',
            backgroundSize: '40px 40px',
          }}
        />
        <div
          ref={heroRef}
          className={`max-w-7xl mx-auto px-4 md:px-6 text-center relative z-10 transition-all duration-700 ${heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <span className="inline-block bg-orange-500/20 text-orange-400 text-xs font-semibold px-3 py-1 rounded-full mb-3 uppercase tracking-wider border border-orange-500/30">
            İletişim
          </span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-4">Bize Ulaşın</h1>
          <p className="text-slate-300 text-base max-w-xl mx-auto">
            Teknik destek, ikinci el ürün sorgusu veya yazılım hakkında her konuda yanınızdayız.
          </p>

          <div
            className={`flex flex-col sm:flex-row gap-3 justify-center mt-8 transition-all duration-700 delay-200 ${heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            <a
              href={WA_HREF}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 hover:scale-105 text-white px-7 py-3.5 rounded-xl font-bold text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              WhatsApp ile Yaz
            </a>
            <a
              href={PHONE_HREF}
              className="inline-flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 hover:scale-105 text-white px-7 py-3.5 rounded-xl font-bold text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-lg"></i>
              0532 541 63 44
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          {/* Left Info Cards */}
          <div ref={cardsRef} className="lg:col-span-2 space-y-3">
            {contactItems.map((item, i) => (
              <div
                key={i}
                className={`bg-white rounded-xl p-4 flex items-start gap-4 border border-slate-100 ${item.hoverBorder} ${item.hoverBg} transition-all duration-300 group cursor-default ${cardsVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}
                style={{ transitionDelay: cardsVisible ? `${i * 80}ms` : '0ms' }}
              >
                <div className={`w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0 ${item.iconBg} ${item.iconColor} group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs text-slate-400 font-medium mb-0.5">{item.title}</p>
                  {item.href ? (
                    <a
                      href={item.href}
                      target={item.href.startsWith('http') ? '_blank' : undefined}
                      rel="noopener noreferrer"
                      className={`font-bold text-sm hover:${item.iconColor} transition-colors cursor-pointer truncate block text-slate-900`}
                    >
                      {item.value}
                    </a>
                  ) : (
                    <p className="text-slate-900 font-bold text-sm">{item.value}</p>
                  )}
                  <p className="text-xs text-slate-400 mt-0.5">{item.sub}</p>
                </div>
                {item.href && (
                  <div className={`w-7 h-7 flex items-center justify-center rounded-lg ${item.iconBg} ${item.iconColor} opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex-shrink-0`}>
                    <i className="ri-arrow-right-up-line text-sm"></i>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Right Form */}
          <div
            ref={formRef}
            className={`lg:col-span-3 bg-white rounded-2xl p-6 md:p-8 border border-slate-100 transition-all duration-700 delay-200 ${formVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`}
          >
            <h2 className="text-xl font-extrabold text-slate-900 mb-2">Mesaj Gönderin</h2>
            <p className="text-slate-500 text-sm mb-6">Mesajınız doğrudan e-posta olarak iletilecektir.</p>

            {status === 'done' ? (
              <div className="text-center py-12">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-green-100 mx-auto mb-4 animate-bounce">
                  <i className="ri-check-line text-3xl text-green-500"></i>
                </div>
                <h3 className="font-bold text-slate-900 text-lg mb-2">Mesajınız İletildi!</h3>
                <p className="text-slate-500 text-sm">En kısa sürede size dönüş yapacağız.</p>
                <button
                  onClick={() => setStatus('idle')}
                  className="mt-5 text-orange-500 text-sm font-medium cursor-pointer hover:text-orange-600"
                >
                  Yeni Mesaj Gönder
                </button>
              </div>
            ) : (
              <form
                onSubmit={handleSubmit}
                data-readdy-form
                id="iletisim-formu"
                className="space-y-4"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-medium text-slate-600 mb-1">Ad Soyad *</label>
                    <input
                      name="name"
                      required
                      value={form.name}
                      onChange={e => setForm({ ...form, name: e.target.value })}
                      className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-orange-400 transition-colors duration-200"
                      placeholder="Adınız Soyadınız"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 mb-1">E-posta *</label>
                    <input
                      name="email"
                      type="email"
                      required
                      value={form.email}
                      onChange={e => setForm({ ...form, email: e.target.value })}
                      className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-orange-400 transition-colors duration-200"
                      placeholder="ornek@email.com"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-medium text-slate-600 mb-1">Telefon</label>
                    <input
                      name="phone"
                      value={form.phone}
                      onChange={e => setForm({ ...form, phone: e.target.value })}
                      className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-orange-400 transition-colors duration-200"
                      placeholder="0532 XXX XX XX"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 mb-1">Konu *</label>
                    <select
                      name="subject"
                      required
                      value={form.subject}
                      onChange={e => setForm({ ...form, subject: e.target.value })}
                      className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-orange-400 cursor-pointer transition-colors duration-200"
                    >
                      <option value="">Konu Seçin</option>
                      <option>Teknik Servis</option>
                      <option>İkinci El Ürün Sorgusu</option>
                      <option>Yazılım Bilgisi</option>
                      <option>Fiyat Teklifi</option>
                      <option>Diğer</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-600 mb-1">
                    Mesaj * <span className="text-slate-400">({form.message.length}/500)</span>
                  </label>
                  <textarea
                    name="message"
                    required
                    rows={5}
                    maxLength={500}
                    value={form.message}
                    onChange={e => setForm({ ...form, message: e.target.value })}
                    className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-orange-400 resize-none transition-colors duration-200"
                    placeholder="Mesajınızı yazın..."
                  />
                  {form.message.length > 500 && (
                    <p className="text-red-500 text-xs mt-1">Mesaj 500 karakteri geçemez.</p>
                  )}
                </div>
                <button
                  type="submit"
                  disabled={status === 'sending' || form.message.length > 500}
                  className="w-full bg-slate-900 hover:bg-orange-500 hover:scale-[1.01] disabled:opacity-50 text-white py-3 rounded-lg font-semibold text-sm transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
                >
                  {status === 'sending' ? (
                    <><i className="ri-loader-4-line animate-spin"></i> Gönderiliyor...</>
                  ) : (
                    <><i className="ri-send-plane-line"></i> Mesaj Gönder</>
                  )}
                </button>
                {status === 'error' && (
                  <p className="text-red-500 text-xs text-center">Bir hata oluştu, lütfen tekrar deneyin.</p>
                )}
              </form>
            )}
          </div>
        </div>

        {/* Map */}
        <div
          ref={mapRef}
          className={`mt-10 rounded-2xl overflow-hidden h-80 border border-slate-200 transition-all duration-700 ${mapVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3059.5!2d32.8260!3d39.9780!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d34f9b0e1a2345%3A0xabcdef1234567890!2zQXlkxLFubMSxa2V2bGVyLCBBbmthcmE!5e0!3m2!1str!2str!4v1700000000000"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            title="Konum Haritası"
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default IletisimPage;
